export function isTemplateEditor(path: string): boolean {
    return path.startsWith('/conf/vwa-ngw18/settings/wcm');
}
